module.exports = __webpack_public_path__ + "static/media/boy-bg.37c32d2f.png";